import axios from '@axios'

export default {
  namespaced: true,
  actions: {
    getProfileData(ctx, id) {
      return new Promise((resolve, reject) => {
        axios.get(`user`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    postProfileData(ctx, { data }) {
      return new Promise((resolve, reject) => {
        axios.post(`auth/account-settings`, data)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },


    postPassword(ctx, { data }) {
      return new Promise((resolve, reject) => {
        console.log(data);
        axios.put(`user/password`, data)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    }
  },
}
